export enum AppointmentFormEnum {
  Idea = 'idea',
  Diagnosis = 'diagnosis',
  Recommendation = 'recommendation'
}
